import axios from 'axios'
import { getBaseUrl } from './getBaseUrl'

const VERSION = '3'

const URL = getApiUrl(process.env.VUE_APP_NODE_ENV)

console.log('API URL: ', URL) //DEBUG

export const SIGN = axios.create({
    baseURL: `${URL}/v${VERSION}`,
})

export const API = axios.create({
    baseURL: `${URL}/v${VERSION}/admin`,
})

API.interceptors.request.use((config) => {
    config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_mz_admin_token')
    return config
}, (err) => {
    return Promise.reject(err)
})

function getApiUrl(str) {
    const url = getBaseUrl()
    if (url)
        return `${url}/api`
    
    switch (str) {
        case 'production':
            return 'https://moezdorovie.org/api'
        case 'development':
            return 'http://localhost:3200/api'
        case 'smev':
            return 'https://smev.moezdorovie.org/api'
        default:
            return 'https://moezdorovie.org/api'
    }
}
